import { Component, Input, NgModule, OnInit } from '@angular/core';

@Component({
    selector: 'app-info-table',
    templateUrl: './info-table.component.html',
    styleUrls: ['./info-table.component.scss'],
    standalone: false
})
export class InfoTableComponent implements OnInit {

	public colSpan: number;

	@Input() public header: string;
	@Input() public data: any[][] = [["No Data"]];

  constructor() {}

  ngOnInit() {
		//? Assign the biggest row length.
		this.colSpan = Math.max(...this.data.map((row) => row.length));

		for (let a = 0; a < this.data.length; a++) {
			const row = this.data[a];
			
			while (row.length < this.colSpan) {
				row.push(null);
			}
		}
  }
}

import { DxTemplateModule, DxAutocompleteModule, DxButtonModule } from 'devextreme-angular';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [InfoTableComponent],
  exports: [InfoTableComponent],
  imports: [DxAutocompleteModule, DxTemplateModule, DxButtonModule, CommonModule]
})
export class InfoTableModule { }
